import React, { useEffect, useContext, useState, Fragment, useRef } from 'react';

import { LoginContext } from '../../hooks/context/LoginContext';

import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Formulario from '../../componentes/formulario/Formulario';
import FormRow from '../../componentes/formulario/FormRow';
import FormInput from '../../componentes/formulario/FormInput';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import { Alert } from '../../componentes/ui/Alert';
import MiSelect from '../../componentes/formulario/MiSelect';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Spinner from 'react-bootstrap/Spinner';
import MiSelectLarge from '../../componentes/formulario/MiSelectLarge';
import MiDataTableStockActivity from './MiDataTableStockActivity';
import axios from 'axios';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';
import { alertService } from '../../services/alertservice';

import { getTitle, getDecodedCookie, getApiUrl } from '../../helpers/helperApp';

function StockActivity(props){

    const cookies = new Cookies();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ idPlantilla, saveIdPlantilla ] = useState(0);
    const [ idCentro, saveIdCentro ] = useState(0);
    const [ idUbicacion, saveIdUbicacion ] = useState(0);
    const [ unidad, saveUnidad ] = useState({value: 0, label: ""});
    const [ loading, saveLoading ] = useState(false);    
    const [ lineas, saveLineas ] = useState([]);   

    // ***** Custom Hook - Lógica de los formularios *****
    const { loadReg } = useLogicForm();

    const idPlantillaRef = useRef(idPlantilla);
    const idCentroRef = useRef(idCentro);
    const idUbicacionRef = useRef(idUbicacion);

    useEffect(() => {
        idPlantillaRef.current = idPlantilla;
        idCentroRef.current = idCentro;
        idUbicacionRef.current = idUbicacion;
    }, [idPlantilla, idCentro, idUbicacion]);

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{                             
                    document.title = getTitle(confPantalla.config.trad, "Consumos");                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);                                            
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);                    
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "undefined" })
            }
                document.querySelector("body").classList.remove("sidebar-open");
        } 

    },[confPantalla])

    const getLineas = async(idPlan=null, idLin=null, idCen=null, idUbi=null) => {

        if(idCentroRef.current != 0 || idCen != null){
            const data = new FormData();
            data.append("validacion", apiKey());
            data.append("idplantilla", idPlan ? idPlan : idPlantilla);
            data.append("idcen", idCen ? idCen : idCentroRef.current);
            data.append("idubi", idUbi ? idUbi : idUbicacionRef.current);
            if(idLin) data.append("idlin", idLin); 
            const respuesta = await axios.post(getApiUrl(window.location.origin)+'/stockactivity/getlineas', data);        
            if( typeof respuesta.data == "string" ){
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: false});            
            }else{
                if(idLin) return respuesta.data;            
                saveLineas(respuesta.data);
            }
        }
    }

    const addLinea = async () => {        
        saveLoading(true);
        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("idplantilla", idPlantilla);
        data.append("iduni", unidad.value);
        data.append("idubi", idUbicacionRef.current);
        data.append("idcen", idCentroRef.current);                                   
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/stockactivity/addLinea', data);                
        if( typeof respuesta.data == "string" ){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: false});            
        }else if(respuesta.data != null){                    
            saveLineas([ ...lineas, respuesta.data[0] ]);
            saveUnidad({value: 0, label: ""});
        }
        saveLoading(false)
    }

    const accion = async(e, rowData, accion) => {         
        if(idCentroRef.current == 0 ){
             alertService.error(`<i class="fal fa-times-octagon mr-1"></i>Seleccione un centro`, {autoClose: false});
             return;
        }

        if(idUbicacionRef.current == 0 ){
             alertService.error(`<i class="fal fa-times-octagon mr-1"></i>Seleccione una ubicación`, {autoClose: false});
             return;
        }

        // Validar fecha
        if(!rowData.fecha || isNaN(new Date(rowData.fecha).getTime())){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>La fecha es obligatoria`, {autoClose: false});
            return;
        }

        // Accion: 0-Restar, 1-Sumar       
        saveLoading(true);
        
        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("linea", JSON.stringify(rowData));
        data.append("accion", accion);
        data.append("idcen", idCentroRef.current);
        data.append("idubi", idUbicacionRef.current);
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/stockactivity/actions', data);                
        if( typeof respuesta.data == "string" ){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: false});            
        }else{                           
            // const lineaAccion = await getLineas(null, rowData.id);                                
            // saveLineas((lineas) =>
            //     lineas.map((linea) =>
            //         linea.id === rowData.id ? lineaAccion[0] : linea
            //     )
            // );                                
            saveLineas((lineas) =>
                lineas.map((linea) =>
                    linea.id === rowData.id ? respuesta.data[0] : linea
                )
            );
        }        
        
        saveLoading(false);
    }

    const historial = (e, rowData) => {                
        props.history.push("/iomovements/"+rowData.iduni+"/"+idCentroRef.current+"/0000-00-00");
    }

    // HANDLES
    const handleSelectPlantilla = async(selectedItem, nameOfComponent) => {
        if( selectedItem ){
            saveIdPlantilla(selectedItem.value);

            saveLoading(true);
            await getLineas(selectedItem.value);
            saveLoading(false); 
        }else{
            saveIdPlantilla(0)
            saveUnidad({value: 0, label: ""});
            saveLineas([]);
        }
    }

    const handleSelectCentro = async(selectedItem, nameOfComponent) => {
        if( selectedItem ){                        
            saveIdCentro(selectedItem.value);            
            saveIdUbicacion(selectedItem.ubidef);            

            saveLoading(true);
            await getLineas(null, null, selectedItem.value);
            saveLoading(false); 
        }else{
            saveIdCentro(0);
            saveIdUbicacion(0);
        }
    }

    const handleSelectUbicacion = async(selectedItem, nameOfComponent) => {
        if( selectedItem ){
            saveIdUbicacion(selectedItem.value);
            saveLoading(true);
            await getLineas(null, null, null, selectedItem.value);
            saveLoading(false);                         
        }else{
            saveIdUbicacion(0)            
        }
    }
     

    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
                {
                    !loadReg ?
                        <Alert fondo={true} />
                    :
                        <Alert />
                }                                
            </div>    
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined
                        ?
                        <Section 
                            titulo={ "Consumos" } 
                            icono={ "fa-thin fa-wave-pulse" } 
                            col={ 12 } 
                            idPrin={ 0 } 
                            informes={{
                                btngenerar : { title : "Imprimir" },
                                getregistro  : "/documentos/getdocumentos",
                                select : {
                                    id: "select-informe",
                                    name: "", 
                                    label : "Informe", 
                                    placeholder : "Seleccionar informe", 
                                    col: "11", 
                                    isclearable : true,
                                    issearchable : true,
                                    datatype : "sql",
                                    data : "stockactivity.informes",
                                    required: false, 
                                    disabled : "",
                                    readonly : "",
                                    disablethisid : false         
                                }
                            }}
                        >
                            <FormRow>
                                <MiSelect  
                                    estadoForm=  { loading ? "readonly" : "" }
                                    val=         { idPlantilla  }   
                                    loading=     { loadReg ? true : false }
                                    id=          { "idplan" }    
                                    name=        { "idplan" }   
                                    label=       { "Plantilla*" }    
                                    placeholder= { "Seleccionar plantilla" }
                                    col=         { 12 } 
                                    isClearable= { true }
                                    isSearchable={ true }
                                    dataType=    { "sql" }
                                    data=        { "stockactivity.idplantilla" }
                                    required=    { false } 
                                    disabled=    { loading ? true : false }
                                    readOnly =   { false }
                                    disablethisid={false}
                                    formulario = { {id: 0} } 
                                    change=      { handleSelectPlantilla }                                                    
                                />
                            </FormRow>
                            <FormRow>
                                <MiSelect  
                                    estadoForm=  { loading ? "readonly" : "" }
                                    val=         { idCentro  }   
                                    loading=     { loadReg ? true : false }
                                    id=          { "idCentro" }    
                                    name=        { "idCentro" }   
                                    label=       { "Centro*" }    
                                    placeholder= { "Centro" }
                                    col=         { 6 } 
                                    isClearable= { true }
                                    isSearchable={ true }
                                    dataType=    { "sql" }
                                    data=        { "stockactivity.centros" }
                                    required=    { false} 
                                    disabled=  { loading ? true : false }
                                    readOnly =   { false}
                                    disablethisid={false}                                    
                                    formulario= { {id: 0} }   
                                    change= { handleSelectCentro }
                                />
                                <MiSelect  
                                    estadoForm=  { loading ? "readonly" : "" }
                                    val=         { idUbicacion  }   
                                    loading=     { loadReg ? true : false }
                                    id=          { "idUbicacion" }    
                                    name=        { "idUbicacion" }   
                                    label=       { "Ubicación*" }    
                                    placeholder= { "Ubicación" }
                                    col=         { 6 } 
                                    isClearable= { true }
                                    isSearchable={ true }
                                    dataType=    { "sql" }
                                    data=        { "stockactivity.ubicaciones" }
                                    required=    { false} 
                                    disabled=  { loading ? true : false }
                                    readOnly =   { false}
                                    disablethisid={false}                                    
                                    formulario= { {id: idCentro} }   
                                    change= { handleSelectUbicacion }
                                    depends={{"control" : "id", "action" : "/ubicaciones/ubicacionesbycentro"}}
                                />
                            </FormRow>
                            <p className="font-italic text-center">{ confPantalla.planificador.controles.modal.required.title }</p> 
                            <FormRow clases={"formedirap"}>                                
                                <MiSelectLarge
                                    regActual={idPlantilla ? idPlantilla : 0}
                                    value={{value: unidad.value, label: unidad.label}}
                                    saveValue={saveUnidad}                                                
                                    label={"Artículo"}
                                    col={10}
                                    confPantalla={confPantalla}
                                    dataType={"sql"}
                                    dataSql={"stockactivity.unidad"}
                                    multiLinea={true}
                                    readOnly={loading == true || loading == null || idPlantilla == 0 ? true : false}                                    
                                />
                                <button 
                                    style={{marginTop: "32px"}} 
                                    id="btnaddline"
                                    className={"btn btn-flat btn-outline-success col-md-2 col-sm-12 mb-4" } 
                                    type="button" 
                                    onClick={ addLinea } 
                                    disabled={ loading == true || loading == null || idPlantilla == 0 || idCentro == 0 || idUbicacion == 0 || unidad.value == 0 ? true : false }
                                >
                                    <i className="fal fa-plus"></i>                                    
                                </button>
                            </FormRow>
                            {
                            loading 
                            ?
                                <div className="text-center">
                                    <Spinner animation="border" />
                                </div>
                            :
                                null
                            }
                            <MiDataTableStockActivity
                                // formulario={{id:0}}
                                estadoForm= { "" }
                                id={"linstockactivity"}
                                columnas={[
                                        { "title": "Artículo", "data": "nomart" },
                                        { "title": "Exis.CEN", "data": "existenciascen", "width": "67px"},
                                        { "title": "Exis.UBI", "data": "existenciasubi", "width": "67px"},
                                        { "title": "Fecha", "data": "fecha", "width": "160px"},
                                        { "title": "Entrada/Consumo", "data": "cantidad", "width": "140px"},
                                        { "title": "Descripción", "data": "descripcion" },
                                        { "title": "Acciones", "data": "acciones", "width": "195px"}                                      
                                    ]}
                                data={lineas}                                
                                order={[[0,"asc"]]}                                
                                pagelength={25}                                                                
                                // saveLoadingTable={ saveLoading }
                                // loadingTable={loading}                                
                                traduction={confPantalla.config.trad.components.datatable}
                                saveData={saveLineas}
                                getLineas={getLineas}   
                                historialFn={historial}
                                accionFn={accion}
                                select={{"style":    "multi"}}
                                idPlantilla={idPlantillaRef.current}
                                idCentro={idCentroRef.current}
                                idUbicacion={idUbicacion} 
                            />
                                                                                                                             
                        </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default StockActivity